import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/icons/save-white.svg'


const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = { class: "w-2/3" }
const _hoisted_3 = { class: "w-1/2 mb-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2 text-sm leading-6 font-semibold tracking-wider text-blue-900" }, " Nama Proyek ", -1)
const _hoisted_5 = { class: "flex gap-4" }
const _hoisted_6 = { class: "w-1/2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2 text-sm leading-6 font-semibold tracking-wider text-blue-900" }, " Tanggal Mulai Proyek ", -1)
const _hoisted_8 = { class: "w-1/2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2 text-sm leading-6 font-semibold tracking-wider text-blue-900" }, " Tanggal Selesai Proyek ", -1)
const _hoisted_10 = { class: "flex gap-3 items-start" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4 border-blue-700" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_assessment_list = _resolveComponent("assessment-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.projectName) = $event)),
            class: "p-2 border rounded w-full"
          }, null, 512), [
            [_vModelText, _ctx.projectName]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.startedAt) = $event)),
              class: "p-2 border rounded w-full"
            }, null, 512), [
              [_vModelText, _ctx.startedAt]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.endedAt) = $event)),
              class: "p-2 border rounded w-full"
            }, null, 512), [
              [_vModelText, _ctx.endedAt]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_router_link, {
          to: "/admin/home",
          class: "px-4 py-2 bg-transparent border-1 border-yellow-400 rounded text-yellow-400 text-sm leading-6 font-semibold flex items-center gap-3"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Batal ")
          ]),
          _: 1
        }),
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.createProject && _ctx.createProject(...args))),
          class: "px-4 py-2 bg-yellow-400 border-1 border-yellow-400 rounded text-white leading-6 text-sm font-semibold flex items-center gap-3"
        }, [
          _hoisted_11,
          _createTextVNode(" Simpan ")
        ])
      ])
    ]),
    _hoisted_12,
    _createVNode(_component_assessment_list, {
      data: _ctx.assessments,
      selectedAssessment: _ctx.selectedAssessment,
      onSetSelectedAssessment: _ctx.setSelectedAssessment
    }, null, 8, ["data", "selectedAssessment", "onSetSelectedAssessment"])
  ]))
}